import type { NextPage } from 'next';

import { GiftCardsContainer } from '../routes/giftCard/GiftCards.container';

const GiftCards: NextPage = () => {
  return <GiftCardsContainer />;
};

GiftCards.getInitialProps = function () {
  return {
    metadata: {
      title: 'Gift Cards',
    },
  };
};

export default GiftCards;
